/* eslint-disable implicit-arrow-linebreak */
import styled, { css } from 'styled-components';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
  isCorrect: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: #ffffff;
  color: #666360;
  border: 1px solid #b1b4c4;
  height: 48px;

  border-radius: 10px;
  padding: 16px;
  width: 100%;

  display: flex;
  align-items: center;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${props =>
    props.isFocused &&
    css`
      color: var(--orange);
      border-color: var(--orange);
    `}

  ${props =>
    props.isFilled &&
    css`
      color: var(--orange);
    `}

  ${props =>
    props.isCorrect &&
    css`
      border-color: green;
      color: green;
    `}

  input {
    color: var(--text);
    flex: 1;
    background: transparent;
    border: 0;
    width: 100%;

    &::placeholder {
      color: var(--gray-line);
    }
  }

  label {
    padding-bottom: 15px;
    color: #2f2f2f;
    font-size: 18px !important;
  }

  svg {
    margin-right: 10px;
  }
`;

export const Label = styled.label`
  font-size: 18px;
`;

export const Error = styled.label`
  height: 20px;
  font-size: 15px;
  margin-bottom: 3px;
  color: #c53030;
  display: flex;
`;
